module.exports = __webpack_public_path__ + "img/account.9345d2be.png";